// extracted by mini-css-extract-plugin
export default {"btn":"AccessButton_btn__omkZF"};